export const ENV = process.env.REACT_APP_ENV;

export const AUTH_API = process.env.REACT_APP_AUTH_API;
export const BASE_API = process.env.REACT_APP_BASE_API;
export const IDM_API = process.env.REACT_APP_IDM_API;